import React from 'react';
import { AutocompleteInput, ReferenceInput } from 'react-admin';
import { CUSTOMER } from './Order.string';

export default function CustomerAutoCompleteInput({
  onSelect,
}: {
  onSelect: (selectedItem: any) => void;
}) {
  return (
    <ReferenceInput
      allowEmpty={true}
      label={`${CUSTOMER.NAME}`}
      variant='outlined'
      reference='customers'
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={(text) => ({ name: text })}
      filter={undefined}
      source='customer.id'
    >
      <AutocompleteInput
        optionText={'name'}
        source='customerName'
        onSelect={onSelect}
      />
    </ReferenceInput>
  );
}
